module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./lngProvider/locales/en_US.json
// module id = 778
// module chunks = 4